<template>
  <div>
    <template v-if="product.loading || isProductSectionsLoading">
      <loading-text></loading-text>
    </template>
    <b-card no-body v-if="!product.loading && !isProductSectionsLoading">
      <b-card-header
        header-bg-variant="primary"
        header-text-variant="white"
        header-tag="h3"
        class="card-header-mobile p-1"
      >
        <b-button
          size="lg"
          variant="link"
          class="p-2"
          @click.stop="handleHideProduct"
          ><b-icon
            icon="arrow-left-circle-fill"
            class="back-icon"
          ></b-icon></b-button
        >{{ product.DisplayName }}
      </b-card-header>
      <b-tabs data-cy="order-product-filter-tabs"
        v-if="product.Sections[0] && product.Sections[0].Tabs.length > 0"
        card
        :nav-class="[
          'filter-tabs',
          product.Sections[0].Tabs.length === 1 &&
          product.Sections[0].Tabs[0].DisplayName === ''
            ? 'd-none'
            : '',
        ]"
      >
        <b-tab
          v-for="sectionTab in sectionTabsWithItems"
          :key="'sectionTab-' + sectionTab.SectionTabId"
          :title="sectionTab.DisplayName"
          :active="sectionTab.active"
          :data-cy="'order-product-tabs'"
        >
          <b-container fluid class="order-sections" data-cy="order-sections-container">
            <b-row no-gutters>
              <b-card
                :class="'col-12 col-sm-' + sectionItem.Cols"
                no-body
                class="table-card"
                v-for="sectionItem in itemsWithModels(sectionTab.Items)"
                :key="'sectionItem-card-' + sectionItem.key"
              >
                <b-card-header
                  :key="'sectionItem-header-' + sectionItem.key"
                  class="py-1"
                  header-tag="h3"
                  v-if="sectionItem.DisplayName"
                >
                  {{ sectionItem.DisplayName }}
                </b-card-header>
                <b-card-body
                  :key="'sectionTable-body-' + sectionItem.key"
                  v-if="sectionItem.SectionTableId"
                  class="p-1 w-auto"
                >
                  <order-product-tabs-table
                    :product="product"
                    :sectionTable="sectionItem"
                    :key="'sectionTable-table-' + sectionItem.key"
                    :saveCartItem="saveCartItem"
                    :updateTerm="updateTerm"
                    :isUsedByRequestSite="isUsedByRequestSite"
                    :isUsedByOrdersSite="isUsedByOrdersSite"
                    :handleAddItemToOrder="handleAddItemToOrder"
                  ></order-product-tabs-table>
                </b-card-body>
              </b-card>
            </b-row>
          </b-container>
        </b-tab>
      </b-tabs>
      <h5 v-else class="text-center m-2">No items found.</h5>
    </b-card>
  </div>
</template>

<script lang="ts">
import LoadingText from '@/components/utility/loading-text.vue'
import { Product, SectionItem } from '@/store/product/types'
import { Component, Vue, Prop } from 'vue-property-decorator'
import { namespace } from 'vuex-class'
import OrderProductTabsTable from '../utility/order-product-tabs-table.vue'

const nsProduct = namespace('product')
const nsProductFinder = namespace('product-finder')
const nsCart = namespace('cart')

@Component({
  components: {
    'order-product-tabs-table': OrderProductTabsTable,
    'loading-text': LoadingText,
  },
})
export default class extends Vue {
  @Prop()
  public updateTerm: any

  @Prop()
  public isUsedByOrdersSite!: false

  @Prop()
  public isUsedByRequestSite!: false

  @Prop()
  public handleAddItemToOrder: any

  @nsProduct.State('product')
  public product!: Product

  @nsProductFinder.State('isProductSectionsLoading')
  public isProductSectionsLoading!: boolean

  @nsCart.Action('saveCartItem')
  private saveCartItem: any

  public handleHideProduct() {
    this.$emit('hideProductModels')
  }

  get sectionTabsWithItems() {
    return this.product.Sections[0].Tabs.filter(
      (t) =>
        t.Items.length > 0 &&
        t.Items.filter((s) => s.SectionItemType === 'ModelTable').length > 0,
    )
  }

  public itemsWithModels(items: SectionItem[]) {
    return items.filter((s) => s.SectionItemType === 'ModelTable')
  }
}
</script>
<style scoped>
.zoom-icon {
  position: absolute;
  bottom: 30px;
  right: 30px;
}

.body-section {
  padding: auto 0px;
  width: 100%;
}

.prop65-text {
  font-size: 0.75rem;
}

h3 {
  line-height: 1.5;
  font-size: 20px;
}

.order-sections {
  height: 60vh;
  overflow-y: auto;
}

.card-header-mobile {
  font-size: medium;
  display: flex;
  justify-content: space-around;
  align-items: center;
}

.back-icon {
  color: white;
}

@media (max-width: 767px) {
  .order-sections {
    height: 100%;
  }
}
</style>
